(() => {
  const state = window.__kisscurlsBioEducation || (window.__kisscurlsBioEducation = { sent: new Set() });

  function analyticsAllowed() {
    return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  }

  function init(root) {
    if (root.dataset.eduInitialized) return;
    root.dataset.eduInitialized = 'true';
    const productPath = root.dataset.productPath;
    const base = {
      block_id: 'biotasmy_education', block_version: 'edu_v3',
      layout_variant: root.dataset.layoutVariant, measurement_version: 'm1'
    };
    const availability = () => {
      const selected = document.querySelector('product-info input[name="id"]');
      if (selected && root.dataset.variants) {
        try {
          const variant = JSON.parse(root.dataset.variants).find(item => String(item.id) === selected.value);
          if (variant) return variant.available ? 'available' : 'sold_out';
        } catch (_) {}
      }
      return root.dataset.available === 'true' ? 'available' : 'sold_out';
    };
    const send = (event, detail = {}, onceKey) => {
      if (!analyticsAllowed()) return;
      const key = onceKey && `${productPath}:${onceKey}`;
      if (key && state.sent.has(key)) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event, ...base, product_availability: availability(), ...detail });
      if (key) state.sent.add(key);
    };
    const ready = () => send('edu_block_ready', {}, 'ready');
    ready();
    document.addEventListener('visitorConsentCollected', ready);

    const whatsappWidget = document.getElementById('whatsapp-widget');
    if (whatsappWidget) {
      new IntersectionObserver(entries => {
        whatsappWidget.classList.toggle('bio-edu-widget-hidden', entries[0].isIntersecting);
      }).observe(root);
    }

    const marker = root.querySelector('[data-view-marker]');
    let viewTimer;
    let markerVisible = false;
    const cancelView = () => { clearTimeout(viewTimer); viewTimer = undefined; };
    const startView = () => {
      cancelView();
      if (!markerVisible || document.visibilityState !== 'visible' || !analyticsAllowed()) return;
      viewTimer = setTimeout(() => {
        if (markerVisible && document.visibilityState === 'visible') send('edu_block_view', {}, 'view');
      }, 1000);
    };
    const viewObserver = new IntersectionObserver(entries => {
      markerVisible = entries[0].intersectionRatio >= .5;
      if (markerVisible) startView(); else cancelView();
    }, { threshold: [.5] });
    viewObserver.observe(marker);
    document.addEventListener('visibilitychange', startView);
    document.addEventListener('visitorConsentCollected', startView);
    if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
        if (!error) {
          ready();
          startView();
        }
      });
    }

    root.querySelectorAll('[data-faq-id]').forEach(details => {
      details.addEventListener('toggle', () => {
        if (details.open) send('edu_block_interaction', {
          action: 'faq_open', element_id: details.dataset.faqId, placement: 'education_faq'
        }, `faq:${details.dataset.faqId}`);
      });
    });
    root.querySelectorAll('[data-edu-action]').forEach(link => {
      link.addEventListener('click', () => send('edu_block_interaction', {
        action: link.dataset.eduAction, element_id: link.dataset.elementId,
        placement: link.closest('.bio-edu__faq') ? 'education_faq' : 'education'
      }));
    });
    root.querySelectorAll('[data-edu-whatsapp]').forEach(link => {
      link.addEventListener('click', event => {
        event.preventDefault();
        send('whatsapp_click', {
          element_id: link.dataset.elementId,
          placement: link.closest('.bio-edu__faq') ? 'education_faq' : 'education'
        });
        window.open(`${link.href}?text=${encodeURIComponent(link.dataset.message)}`, '_blank', 'noopener,noreferrer');
      });
    });

    const track = root.querySelector('[data-media-track]');
    if (!track) return;
    const slider = root.querySelector('.bio-edu__slider');
    let manuallyNavigated = false;
    let mediaTimer;
    const recordMediaView = slide => {
      clearTimeout(mediaTimer);
      if (manuallyNavigated && slide && document.visibilityState === 'visible') {
        const id = slide.dataset.mediaId;
        mediaTimer = setTimeout(() => send('edu_block_interaction', {
          action: 'media_view', element_id: id, placement: 'education'
        }, `media:${id}`), 1000);
      }
    };
    slider.querySelectorAll('.slider-button').forEach(button => {
      button.addEventListener('click', () => { manuallyNavigated = true; });
    });
    let pointerStartX;
    track.addEventListener('pointerdown', event => { pointerStartX = event.clientX; }, { passive: true });
    track.addEventListener('pointerup', event => {
      if (pointerStartX !== undefined && Math.abs(event.clientX - pointerStartX) > 30) manuallyNavigated = true;
      pointerStartX = undefined;
    }, { passive: true });
    track.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') manuallyNavigated = true;
    });
    slider.addEventListener('slideChanged', event => recordMediaView(event.detail.currentElement));
    document.addEventListener('visibilitychange', () => { if (document.hidden) clearTimeout(mediaTimer); });

    const dialog = root.querySelector('[data-media-dialog]');
    const dialogImage = dialog.querySelector('[data-dialog-image]');
    root.querySelectorAll('[data-media-zoom]').forEach(button => {
      button.addEventListener('click', () => {
        const slide = button.closest('[data-media-id]');
        const image = button.querySelector('img');
        dialogImage.src = image.currentSrc || image.src;
        dialogImage.alt = image.alt;
        dialog.showModal();
        send('edu_block_interaction', {
          action: 'media_zoom', element_id: slide.dataset.mediaId, placement: 'education'
        }, `zoom:${slide.dataset.mediaId}`);
      });
    });
    dialog.querySelector('[data-dialog-close]').addEventListener('click', () => dialog.close());
  }

  function start() {
    document.querySelectorAll('[data-bio-education]').forEach(init);
    document.querySelectorAll('[data-bio-education-anchor]').forEach(anchor => {
      if (anchor.dataset.eduAnchorInitialized) return;
      anchor.dataset.eduAnchorInitialized = 'true';
      if (!document.getElementById('bio-tasmy-education')) anchor.closest('[data-bio-education-summary]').hidden = true;
      anchor.addEventListener('click', () => {
        const root = document.querySelector('[data-bio-education]');
        if (!root || !analyticsAllowed()) return;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'edu_block_interaction', block_id: 'biotasmy_education', block_version: 'edu_v3', layout_variant: root.dataset.layoutVariant, measurement_version: 'm1', action: 'anchor_click', element_id: 'PDP-01', placement: 'product_summary', product_availability: root.dataset.available === 'true' ? 'available' : 'sold_out' });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
